export default __webpack_public_path__ + "static/media/Stats_Assets.eff7279c.svg";